<template>
  <div id="app">
      <RouterView />
      <Loading v-if="isLoading" />
      <ModalAlert ref="ModalAlert" />
      <ModalConfirm ref="ModalConfirm" />
  </div>
</template>

<script>
import Loading from "@/components/common/Loading.vue";
import ModalAlert from "@/components/common/ModalAlert.vue";
import ModalConfirm from "@/components/common/ModalConfirm.vue";
import { modalService } from "@/services/modalService";

export default {
  name: "App",
  components: {
    Loading,
    ModalAlert,
    ModalConfirm,
  },
  provide() {
    return {
      $alert: () => this.$refs.ModalAlert,
      $confirm: () => this.$refs.ModalConfirm,
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters["uiStore/isLoading"];
    },
  },
  mounted() {
    modalService.register(this.$refs.ModalAlert, this.$refs.ModalConfirm);
  },
};
</script>

